export const DEFAULT_CRITICALITY_FILTERS = {
  HIGH: false,
  MEDIUM: false,
  LOW: false,
  IGNORE: false,
  UNMARKED: false,
  NOTES: false,
};

export const createDefaultCriticalityFilters = () => ({
  ...DEFAULT_CRITICALITY_FILTERS,
});

export const CRITICALITY_LABELS = {
  UNMARKED: "Unmarked",
  HIGH: "High",
  MEDIUM: "Medium",
  LOW: "Low",
  IGNORE: "Ignore",
};
